import { API_ENDPOINT } from '../constants';
import { HTTP } from './http.service';

export const ChannelsService = {
  getAccountsWhatsApp: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}channels/whatsapp`);
  },
  saveAccountWhatsApp: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}channels/whatsapp`, data);
  },
  updateAccountWhatsApp: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}channels/whatsapp`, data);
  },
  sendMessageTestWA: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}whatsapp/send/test`, data);
  },
  changeStatusWA: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}channels/whatsapp/status`, data);
  },
  getAgentsRCS: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}agents/rcs`);
  },
  getOutputsRCS: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}channels/rcs/output`);
  },
  addOutputRCS: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}channels/rcs/output`, data);
  },
  addAgentsRCS: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}agents/rcs`, data);
  },
  updateOutputRCS: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}channels/rcs/output`, data);
  },
  updateAgentsRCS: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}agents/rcs`, data);
  },
  getAgentsCataogue: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}agents/rcs`);
  },
  changeStatusAgents: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}agents/rcs/status`, data);
  },
  changeOutputStatus: (data: any) => {
    return HTTP.patch(`${API_ENDPOINT.CORE}channels/rcs/output/${data.id}/status`, {
      status: data.status
    });
  },
  sendMessageRCS: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}rcs/send/test`, data);
  },
  getOutputsSMS: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}channels/sms/output`);
  },
  getMasksSMS: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}masks/sms`);
  },
  addOutputSMS: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}channels/sms/output`, data);
  },
  updateOutputSMS: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}channels/sms/output`, data);
  },
  addMasksSMS: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}masks/sms`, data);
  },
  updateMasksSMS: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}masks/sms`, data);
  },
  sendMessageTestSMS: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}channels/sms/send/test`, data);
  },
  changeStatusMasks: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}masks/sms/status`, data);
  },
  changeOutputStatusSMS: (data: any) => {
    return HTTP.patch(`${API_ENDPOINT.CORE}channels/sms/output/${data.id}/status`, {
      status: data.status
    });
  },
  getAccountsWhatsAppForAccount: (accountId: string) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}channels/whatsapp/account/${accountId}`);
  },
  getMasksSMSForAccount: (accountId: string) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}masks/sms/account/${accountId}`);
  },
  getAgentsRCSForAccount: (accountId: string, type: string) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}agents/rcs/account/${accountId}/type/${type}`);
  },
  getMailingAccounts: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}channels/mailing`);
  },
  saveMailingAccount: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}channels/mailing`, data);
  },
  updateMailingAccount: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}channels/mailing`, data);
  },
  changeStatusMailingAccount: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}channels/mailing/status`, data);
  },
  getMailingProviders: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}channels/providers/mailing`);
  },
  sendMessageTestEmail: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}channels/mailing/send/test`, data);
  }
};
